import { authFetch } from './authFetch';
import { Notification } from '../types/Notification';

const UNREAD_TTL_MS = 15_000;

let cachedUnread: Notification[] | null = null;
let cachedAt = 0;
let inFlight: Promise<Notification[]> | null = null;
let cacheVersion = 0;

const isFresh = () => cachedUnread !== null && Date.now() - cachedAt < UNREAD_TTL_MS;

export const getUnreadNotifications = async (
  options: { force?: boolean } = {}
): Promise<Notification[]> => {
  const { force = false } = options;

  if (!force && isFresh()) {
    return cachedUnread as Notification[];
  }

  if (inFlight) {
    return inFlight;
  }

  const requestVersion = cacheVersion;
  const request = (async () => {
    const res = await authFetch('/api/notifications?unreadOnly=true');
    const data = await res.json();
    const unread = Array.isArray(data) ? (data as Notification[]) : [];

    if (requestVersion === cacheVersion) {
      cachedUnread = unread;
      cachedAt = Date.now();
    }

    return unread;
  })();

  inFlight = request;

  try {
    return await request;
  } finally {
    if (inFlight === request) {
      inFlight = null;
    }
  }
};

export const invalidateUnreadNotifications = (): void => {
  cacheVersion += 1;
  cachedUnread = null;
  cachedAt = 0;
  inFlight = null;
};

export const UNREAD_NOTIFICATIONS_TTL_MS = UNREAD_TTL_MS;
